const KeyFigureGridTypes = {
  HORIZONTAL: 'horizontal',
  TWO_COLUMNS: 'two-columns',
};

module.exports = KeyFigureGridTypes;
